import styled from "styled-components";
import {
	COLOR_WHITE,
	FONT_WT_MEDIUM,
	COLOR_RB_PURPLE_300,
	COLOR_RB_PURPLE_200,
	COLOR_RB_PURPLE_50,
	COLOR_RB_PURPLE_100,
	COLOR_RB_NIGHTSHADE_800,
} from "@website-builder/utilities-index";

export const StyledButton = styled.button`
	padding: 0.625rem 1rem;
	border-radius: 0.25rem;
	font-family: var(--ff-haffer-xh);
	font-weight: var(--fw-haffer-xh-2);
	font-size: var(--fs-1);
	line-height: var(--lh-6);
	transition:
		background 0.2s,
		border 0.2s;
	display: inline-block;
	box-sizing: border-box;
	margin: 0;
	max-height: 50px;
	min-height: 42px;
	text-align: center;
	color: ${(props) =>
		props.type === "outline"
			? props.darkBg
				? COLOR_RB_PURPLE_100
				: COLOR_RB_PURPLE_300
			: props.darkBg
				? COLOR_RB_PURPLE_300
				: COLOR_WHITE};
	cursor: pointer;
	background-color: ${(props) =>
		props.type === "outline"
			? "transparent"
			: props.darkBg
				? COLOR_RB_PURPLE_100
				: COLOR_RB_PURPLE_300};
	border: ${(props) =>
		`1px solid ${props.darkBg ? COLOR_RB_PURPLE_100 : COLOR_RB_PURPLE_300}`};
	&:focus {
		outline: none;
	}
	transition: background-color 0.2s ease-out;
	&:hover {
		${(props) =>
			props.type === "outline"
				? `background-color: ${COLOR_RB_PURPLE_100};
        border-color: ${COLOR_RB_PURPLE_100};
    color: ${props.darkBg ? COLOR_RB_NIGHTSHADE_800 : COLOR_RB_PURPLE_300};
    ;`
				: `background-color:${
						props.darkBg ? COLOR_RB_PURPLE_50 : COLOR_RB_PURPLE_200
					};
        border-color: ${
					props.darkBg ? COLOR_RB_PURPLE_50 : COLOR_RB_PURPLE_200
				};
    color: ${props.darkBg ? COLOR_RB_PURPLE_300 : COLOR_WHITE};
    ;`}
	}
`;
